import { render, staticRenderFns } from "./QuestionNavi.vue?vue&type=template&id=23fd9816&"
import script from "./QuestionNavi.vue?vue&type=script&lang=js&"
export * from "./QuestionNavi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports